<template>
  <div class="careRecordEdit">
    <el-dialog
      title="添加关怀记录"
      :visible.sync="visible"
      width="380px"
      :before-close="close">
      <div class="content">
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="沟通人" prop="assignCreateBy">
            <el-select v-model="form.assignCreateBy" filterable placeholder="请选择" style="width: 100%">
              <el-option v-for="user in userList" :key="user.userId" :label="user.nickName" :value="user.userId" />
            </el-select>
          </el-form-item>
          <el-form-item label="沟通日期" prop="assignCreateTime">
            <el-date-picker
              v-model="form.assignCreateTime"
              type="date"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              :editable="false"
              :clearable="false"
              placeholder="请选择"
              style="width: 100%" />
          </el-form-item>
          <el-form-item label="沟通方式" prop="contactWay">
            <el-radio-group v-model="form.contactWay">
              <el-radio :label="1">电话</el-radio>
              <el-radio :label="2">微信</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="关怀笔记" prop="content">
            <el-input
              v-model="form.content"
              type="textarea"
              :rows="4"
              resize="none"
              maxlength="100"
              show-word-limit
              placeholder="请输入" />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="sumbit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import req from '@/utils/request'
  export default {
    name: 'careRecordEdit',
    data() {
      return {
        visible: false,
        patientId: '',
        userList: [],
        form: {
          assignCreateBy: '',
          assignCreateTime: '',
          contactWay: 1,
          content: ''
        },
        pickerOptions: {
          disabledDate(time) {
            const min = new Date()
            min.setHours(0, 0, 0, 0)
            min.setDate(min.getDate() - 7)
            return time.getTime() < min.getTime()
          }
        },
        rules: {
          assignCreateBy: [{ required: true, message: '请选择沟通人', trigger: 'change' }],
          assignCreateTime: [{ required: true, message: '请选择沟通日期', trigger: 'change' }],
          contactWay: [{ required: true, message: '请选择沟通方式', trigger: 'change' }],
          content: [{ required: true, message: '请输入关怀笔记', trigger: 'blur' }]
        }
      }
    },
    methods: {
      open (patientId) {
        this.visible = true

        this.patientId = patientId
        this.form.assignCreateBy = sessionStorage.getItem('user') && JSON.parse(sessionStorage.getItem('user')).userId || ''
        this.form.assignCreateTime = new Date().Format('yyyy-MM-dd')
        this.form.contactWay = 1
        this.form.content = ''

        this.getUserList()
      },
      // 获取指定门店下的人员列表
      async getUserList() {
        const res = await req.get('/system/user/list')
        if (res.code === 200) {
          this.userList = res.rows || []
        }
      },
      close () {
        this.visible = false

        this.patientId = ''
        this.form.assignCreateBy = ''
        this.form.assignCreateTime = ''
        this.form.contactWay = 1
        this.form.content = ''
      },
      async sumbit () {
        this.$refs['form'].validate(async valid => {
          if (valid) {
            const res = await req.post('/physio/careRecord/add', {
              patientId: this.patientId,
              ...this.form
            })
            if (res.code === 200) {
              this.$message.success('添加成功')
              this.close()
              this.$emit('success')
            }
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .careRecordEdit /deep/ .el-dialog__header {
    padding: 12px 24px;
  }

  .careRecordEdit /deep/ .el-dialog__headerbtn {
    top: 16px;
    right: 18px;
  }

  .careRecordEdit /deep/ .el-dialog__body {
    padding: 0;
  }

  .careRecordEdit /deep/ .el-dialog__footer {
    padding: 0;
  }

  .content {
    box-sizing: border-box;
    padding: 20px 24px;
    width: 100%;
  }

  .footer {
    padding: 8px 24px 16px;
  }
</style>